import { TCommentListItem } from 'components/CommentsWidget/types';
import { TAssignee } from 'features/assignee/types';
import { TAttachment } from 'features/file/types';
import { TIncomingInternalDocumentDetail } from 'features/internal-document/incoming/types';
import { TOutgoingInternalDocumentDetail } from 'features/internal-document/outgoing/types';
import { StrictUnion } from 'utils/types';

export type InternalDocumentState = {
  internalDocumentDetail: StrictUnion<
    TIncomingInternalDocumentDetail | TOutgoingInternalDocumentDetail
  > | null;
  internalDocumentComments: TCommentListItem[] | null;
};

export enum INTERNAL_DOCUMENT_TYPE {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
  E_SIGN = 'E-SIGN',
}

export enum INTERNAL_DOCUMENT_STATUS {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
}

export enum INTERNAL_URGENCY_LEVEL {
  URGENT = '001', // Khẩn
  EXPRESS = '002', // Hỏa tốc
  TIMED_EXPRESS = '003', // Hỏa tốc hẹn giờ
}

export type TLinkedWorkInInternalDocument = {
  code: string;
  title: string;
};

export type TGetInternalDocumentDetailParams = {
  type: INTERNAL_DOCUMENT_TYPE;
  documentCode: string;
};

export type TInternalDocumentDetail = {
  id: number;
  code: string;
  title: string;
  authority_name: string;
  authority_issued_id: number;
  attachments: TAttachment[];
  book_group_id: number;
  book_id: number;
  document_number: string;
  date_issued: string;
  created_at: string;
  created_by: string;
  document_status: INTERNAL_DOCUMENT_STATUS;
  signer?: string;
  urgency_level?: INTERNAL_URGENCY_LEVEL;
  linked_works?: TLinkedWorkInInternalDocument[];
};

export type TCreateInternalDocumentCommentPayload = {
  documentCode: string;
  data: {
    content: string;
    file_ids: string[];
  };
};

export type TDeleteInternalDocumentCommentPayload = {
  documentCode: string;
  commentId: string;
};

export type TUpdateDocumentAssigneeAndStatusPayload = {
  documentCode: string;
  data: {
    document_status: INTERNAL_DOCUMENT_STATUS;
    start_date: string | null;
    end_date: string | null;
    new_items: TAssignee[];
    remove_items: TAssignee[];
  };
};

export type TCheckExistingInternalDocumentNumberQueryResponse = {
  message: string;
  status: 'OK' | 'WARNING';
};

export type TCheckExistingInternalDocumentNumberQueryParams = {
  book_id: number;
  document_number: string;
  type: INTERNAL_DOCUMENT_TYPE;
};

export type TUpdateInternalDocumentPayload<T> = {
  documentCode: string;
  data: T & {
    attachments: {
      new_items: TAttachment[];
      remove_items: TAttachment[];
    };
    update_type: INTERNAL_DOCUMENT_TYPE;
  };
};
